import { z } from 'zod';
export const API_VERSION = 'v1';
export const API_PREFIX = `/api/${API_VERSION}`;
export const problemDetailsSchema = z.object({
    type: z.string(),
    title: z.string(),
    status: z.number().int().min(400).max(599),
    detail: z.string().optional(),
    instance: z.string().optional(),
    code: z.string(),
    correlationId: z.string().optional(),
    errors: z.record(z.string(), z.array(z.string())).optional(),
});
export const healthResponseSchema = z.object({
    status: z.literal('ok'),
    service: z.literal('golive-api'),
    version: z.string(),
    timestamp: z.iso.datetime(),
});
export const readinessResponseSchema = z.object({
    status: z.enum(['ready', 'not_ready']),
    database: z.enum(['up', 'down']),
    timestamp: z.iso.datetime(),
});
export const pageQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
    search: z.string().trim().min(1).max(200).optional(),
    sort: z
        .string()
        .regex(/^[A-Za-z][A-Za-z0-9_.]*$/)
        .optional(),
    sortDirection: z.enum(['asc', 'desc']).default('asc'),
    filter: z.record(z.string().min(1), z.union([z.string(), z.array(z.string())])).optional(),
});
